import React, { FC } from 'react';
import OWTag from '../../common/OWTag';

// `locationIds` is the raw value from the guide record. Wire contract:
//   undefined / null  -> nothing configured ("No Locations")
//   []                -> wildcard           ("All Locations")
//   [id, ...]         -> render one pill per hydrated location name
const TSLocationsDisplay: FC<any> = ({ locations = [], locationIds, notSpecified }) => {
	const isNoneConfigured = locationIds === undefined || locationIds === null;
	return (
		<div className="flex flex-row flex-wrap items-center gap-2">
			{isNoneConfigured ? (
				<OWTag>{'No Locations'}</OWTag>
			) : locations.length > 0 ? (
				locations.map((_) => _.name).map((loc, idx) => <OWTag key={`ts-loc-${idx}`}>{loc}</OWTag>)
			) : (
				<OWTag>{'All Locations'}</OWTag>
			)}
		</div>
	);
};

export default TSLocationsDisplay;
